import React, { SyntheticEvent, useState } from "react";
import {
  Table,
  ScrollArea,
  Grid,
  Button,
  Divider,
  ActionIcon,
} from "@mantine/core";
import { Edit, Archive } from "tabler-icons-react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { deleteSemester, getSemesterDetails } from "./queries";
import { Form } from "./form";

const SemesterView = () => {
  const [isOpenForm, setOpenForm] = useState(false);
  const [data, setData] = useState<SemesterProps | null>(null);
  const queryClient = useQueryClient();
  const { mutate: mutDeleteSemester } = useMutation(deleteSemester, {
    onSuccess: (newData) => {
      queryClient.invalidateQueries();
    },
  });

  const { isLoading, data: semesterData = [] } = useQuery(
    "semesters",
    getSemesterDetails,
    {
      staleTime: 60000,
      refetchOnWindowFocus: false,
    }
  );

  const onUpdateData = (payload: SemesterProps) => {
    setData(payload);
    setOpenForm(true);
  };

  const onRestForm = () => {
    setOpenForm(false);
    setData(null);
  };

  const rows =
    semesterData &&
    semesterData.map((row: SemesterProps) => {
      return (
        <tr key={row.id}>
          <td>{row.id}</td>
          <td>{row.sem}</td>
          <td>{row.available_on_registration ? "Yes" : "No"}</td>
          <td>{row.available_on_filter ? "Yes" : "No"}</td>
          <td>{row.isactive ? "Yes" : "No"}</td>
          <td>
            <Grid columns={2}>
              <Grid.Col span={1}>
                <ActionIcon
                  title="Update"
                  onClick={() => onUpdateData({ ...row })}
                >
                  <Edit size={25} strokeWidth={2} color={"green"} />
                </ActionIcon>
              </Grid.Col>
              <Grid.Col span={1}>
                <ActionIcon
                  title="Delete"
                  onClick={() => mutDeleteSemester({ id: Number(row.id) })}
                >
                  <Archive size={25} strokeWidth={2} color={"red"} />
                </ActionIcon>
              </Grid.Col>
            </Grid>
          </td>
        </tr>
      );
    });

  if (isLoading) {
    // TODO loader on data loading
    return null;
  }
  return (
    <>
      <Grid justify={"flex-end"}>
        <Grid.Col lg={1}>
          <Button
            variant="light"
            onClick={(e: SyntheticEvent) => setOpenForm(true)}
          >
            Create
          </Button>
        </Grid.Col>

        <Grid.Col>
          <Divider />
          <ScrollArea
            offsetScrollbars
            style={{ height: 700, padding: 15 }}
            scrollHideDelay={1000}
          >
            <Table
              sx={{ minWidth: 800 }}
              verticalSpacing="xs"
              horizontalSpacing={"xl"}
            >
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Semester</th>
                  <th>Available On Registration</th>
                  <th>Available On Filter</th>
                  <th>Is Active</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>{rows}</tbody>
            </Table>
          </ScrollArea>
        </Grid.Col>
      </Grid>
      <Form
        isOpenModal={isOpenForm}
        setOpenForm={setOpenForm}
        onReset={onRestForm}
        data={data}
      />
    </>
  );
};

export default SemesterView;
